import { createRef, useRef } from 'react';
import stylesBase from './Base.module.css';
import styles from './FieldPopUp.module.css';
import { Base } from './Base';

function FieldPopUp({
    Title,
    TitleDom,
    Fields,
    FieldIcons,
    OnCancel,
    OnSend,
    CancelButtonText,
    SendButtonText,
    SendButtonCustomClass,
    OpenFocused,
    FlexRow,
    FullPopUp
}) {
    const refsFields = useRef([]);
    const defaultPlaceholder = 'Escreva...';
    function ViewFields() {
        if (!Fields) return null;
        refsFields.current = Object.keys(Fields).map((_, index) => refsFields.current[index] || createRef());
        if (OpenFocused) requestAnimationFrame(() => { refsFields.current[0].current.focus() })
        return (
            <div className={`${styles.Container} ${FlexRow ? styles.Row : ''}`}>
                {Object.entries(Fields).map(([key, { name, type, events, placeholder, value, defaultValue, onClick, onChange, className, input_id, readOnly, multiple }], index) => (
                    <div key={key} className={styles.ContainerField}>
                        <label className={styles.Message}>{name} {FieldIcons[key]}</label>
                        {(() => {
                            const isTextarea = type === 'text';
                            const InputComponent = isTextarea ? 'textarea' : 'input';
                            const inputProps = {
                                ref: refsFields.current[index],
                                className: `${styles.UserInput} ${className}`,
                                placeholder: placeholder || defaultPlaceholder,
                                onClick,
                                onChange,
                                id: input_id,
                                readOnly: !!readOnly,
                                multiple: !!multiple,
                                ...events,
                                ...(defaultValue !== undefined
                                    ? { defaultValue }
                                    : { value })
                            };

                            return <InputComponent type={!isTextarea ? type : undefined} {...inputProps} />;
                        })()}
                    </div>
                ))}
            </div>
        );
    }

    function onClickSend() {
        OnSend?.(refsFields.current?.map(ref => ref.current?.value).filter(value => value !== undefined), refsFields.current);
    }

    return (
        <Base
            Title={Title}
            TitleDom={TitleDom}
            OnClose={OnCancel}
            ViewContent={<ViewFields />}
            ViewButtons={
                <div className={stylesBase.ContainerActionButton}>
                    {CancelButtonText && <button
                        className={`${stylesBase.ActionButton} ${stylesBase.ActionButtonCancel}`}
                        onClick={OnCancel}
                    >{CancelButtonText}</button>}
                    {SendButtonText && <button
                        className={`${stylesBase.ActionButton} ${stylesBase.ActionButtonSend} ${SendButtonCustomClass}`}
                        onClick={onClickSend}
                    >{SendButtonText}</button>}
                </div>
            }
            FullPopUp={FullPopUp}
        ></Base>
    );
}


export function ShowFieldPopUp({
    Title, TitleDom, OnSend, OnCancel, Fields = [
        {
            name: 'Exemplo 1:',
            type: 'text',
            events: {
                onClick: () => { console.log('Exemplo 1: click') },
                onChange: () => { console.log('Exemplo 1: change') },
            }
        },
        {
            name: 'Exemplo 2:',
            type: 'number',
            events: {
                onClick: () => { console.log('Exemplo 2: click') },
                onChange: () => { console.log('Exemplo 2: change') },
            }
        },
    ],
    FieldIcons = [],
    CancelButtonText = 'Cancelar',
    SendButtonText = 'Enviar',
    SendButtonCustomClass = null,
    OpenFocused = false,
    FlexRow = false,
    FullPopUp = false
}) {
    if (!OnSend || !OnCancel) {
        console.error('[ShowFieldPopUp] - Parâmentros não especificados!')
        return null;
    }

    return <FieldPopUp
        Title={Title}
        TitleDom={TitleDom}
        OnSend={OnSend}
        Fields={Fields}
        FieldIcons={FieldIcons}
        OnCancel={OnCancel}
        CancelButtonText={CancelButtonText}
        SendButtonText={SendButtonText}
        SendButtonCustomClass={SendButtonCustomClass}
        OpenFocused={OpenFocused}
        FlexRow={FlexRow}
        FullPopUp={FullPopUp}
    />
}
